import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative w-full bg-accent-900">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-white font-heading text-lg font-semibold mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}>
              Yoybuy Sheet
            </h4>
            <p className="text-white/40 font-label text-xs leading-relaxed max-w-[200px]">
              Современная система заказа товаров из Китая через удобные электронные таблицы.
            </p>
          </div>

          <div>
            <p className="text-white/35 font-label text-[11px] uppercase tracking-wider mb-4">Рассылка</p>
            <div className="relative mb-2">
              <input
                type="text"
                placeholder="Ваш email"
                className="w-full bg-transparent border-b border-white/15 text-white/50 font-label text-sm pb-2 outline-none placeholder:text-white/25"
              />
              <div className="absolute right-0 top-0 w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white/30 text-sm"></i>
              </div>
            </div>
            <p className="text-white/15 font-label text-[10px]">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-white/30 transition-colors">
                kaspreadsheet.com
              </a>
            </p>
          </div>

          <div>
            <p className="text-white/35 font-label text-[11px] uppercase tracking-wider mb-4">Категории</p>
            <div className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-white/50 font-label text-xs hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  {cat.nameRu}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-white/35 font-label text-[11px] uppercase tracking-wider mb-4">Ссылки</p>
            <div className="space-y-2">
              <Link
                to="/"
                className="block text-white/50 font-label text-xs hover:text-white/80 transition-colors whitespace-nowrap"
              >
                Главная
              </Link>
              <Link
                to="/article/yoybuy-spreadsheet-guide"
                className="block text-white/50 font-label text-xs hover:text-white/80 transition-colors whitespace-nowrap"
              >
                Руководство
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-white/50 font-label text-xs hover:text-white/80 transition-colors whitespace-nowrap"
              >
                Yoybuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-white/50 font-label text-xs hover:text-white/80 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-hidden pb-6">
        <div className="text-[clamp(50px,10vw,140px)] font-heading font-extrabold text-accent-800/25 leading-none tracking-tight whitespace-nowrap"
          style={{ fontFamily: 'var(--font-heading)' }}>
          SPREADSHEET
        </div>
      </div>

      <div className="border-t border-white/5 py-6">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 text-center">
          <p className="text-white/20 font-label text-[11px]">
            &copy; 2026 Yoybuy.top — Все права защищены
          </p>
        </div>
      </div>
    </footer>
  );
}